import { z } from "zod";

const subjectSchema = z.object({
  caseId: z.string().trim().min(1, "Primary ID is required"),
  ids: z
    .object({
      id: z.number().optional(),
      type: z.enum(["caseId", "unosId", "other"]),
      value: z.string().trim().min(1, "Must not be empty"),
    })
    .array()
    .prefault([]),
  type: z.string().prefault("donor"),
  dob: z.date().nullish(),
  sex: z.enum(["M", "F"]).nullish(),
  donorIds: z.string().array().nullish(),
});

export const create = subjectSchema;
export const update = create.extend({ id: z.number() });
